/**
 * In-page Slack persona demo (shared engine for twin-looks section).
 */
(function (global) {
  "use strict";

  var MARK =
    '<svg viewBox="0 0 580 470" aria-hidden="true"><path d="M295 0 H490 L195 470 H0 Z" fill="#2CC9F5"/><path d="M462.5 297 L580 470 H345 Z" fill="#8B45F5"/></svg>';

  var STAGE_HTML =
    '<div class="persona-demo__stage stage">' +
    '<div class="a-wrap"><div class="a-head"><div class="a-meta"><span class="pill" id="a-lab"></span><span id="a-tm"></span></div><h3 class="a-q" id="a-q"></h3></div></div>' +
    '<div class="fw" id="a-fw"><div class="receipt" id="a-rc"><span class="ck">\u2713</span><div><div class="big" id="a-rb"></div><div class="sm" id="a-rs"></div></div></div></div>' +
    '<div class="steps" id="a-steps"></div>' +
    "</div>";

  function sched() {
    var ts = [];
    return {
      later: function (fn, ms) {
        var t = setTimeout(fn, ms);
        ts.push(t);
        return t;
      },
      clear: function () {
        ts.forEach(clearTimeout);
        ts = [];
      },
    };
  }

  function msgLen(m) {
    var s = (m.x || "") + (m.lead || "");
    (m.bl || []).forEach(function (b) {
      s += b[1];
    });
    return s.replace(/<[^>]+>/g, "").length;
  }

  function readMs(m, RM) {
    return RM ? 0 : Math.max(1700, Math.min(5600, 1000 + msgLen(m) * 20));
  }

  function extractJsVar(source, name) {
    var re = new RegExp("var\\s+" + name + "\\s*=");
    var match = re.exec(source);
    if (!match) return undefined;
    var i = match.index + match[0].length;
    while (" \n\r\t".indexOf(source[i]) >= 0) i++;
    var open = source[i];
    if (open !== "{" && open !== "[") return undefined;
    var close = open === "{" ? "}" : "]";
    var depth = 0;
    var j = i;
    var inStr = false;
    var strCh = "";
    for (; j < source.length; j++) {
      var c = source[j];
      if (inStr) {
        if (c === "\\") {
          j++;
          continue;
        }
        if (c === strCh) inStr = false;
        continue;
      }
      if (c === '"' || c === "'") {
        inStr = true;
        strCh = c;
        continue;
      }
      if (c === open) depth++;
      else if (c === close) {
        depth--;
        if (depth === 0) {
          j++;
          break;
        }
      }
    }
    var expr = source.slice(i, j);
    // eslint-disable-next-line no-new-func
    return new Function("return " + expr)();
  }

  function extractOwner(source) {
    var m = source.match(/var\s+OWNER\s*=\s*"([^"]+)"/);
    return m ? m[1] : "Rachel";
  }

  function getScriptText(html) {
    var end = html.lastIndexOf("</script>");
    if (end < 0) return "";
    var start = html.lastIndexOf("<script", end);
    if (start < 0) return "";
    start = html.indexOf(">", start) + 1;
    return html.slice(start, end);
  }

  function extractConfigFromHtml(html) {
    var script = getScriptText(html);
    if (!script) return null;
    var beats = extractJsVar(script, "BEATS");
    var people = extractJsVar(script, "P");
    var channels = extractJsVar(script, "CH");
    if (!beats || !people || !channels) return null;
    return {
      owner: extractOwner(script),
      people: people,
      channels: channels,
      beats: beats,
    };
  }

  function createPersonaDemo(host, config) {
    if (!host || !config) return null;

    var RM =
      global.matchMedia &&
      global.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var P = config.people;
    var CH = config.channels;
    var BEATS = config.beats;
    var OWNER = config.owner || "Rachel";

    host.classList.add("persona-demo");
    host.style.setProperty("--persona-steps", String(BEATS.length));
    host.innerHTML = STAGE_HTML;
    var root = host.querySelector(".persona-demo__stage") || host;

    function $(sel) {
      return root.querySelector(sel);
    }

    function Slack(fwHost, S, opts) {
      opts = opts || {};
      var f = document.createElement("div");
      f.className = "frame" + (opts.annot ? " annot" : "");
      var sb =
        '<div class="sb"><div class="ws">Meridian</div><div class="sec">Channels</div>';
      CH.slice(1).forEach(function (c) {
        sb +=
          '<div class="c" data-c="' +
          c[0] +
          '"><span class="h">#</span>' +
          c[0] +
          "</div>";
      });
      sb +=
        '<div class="sec">Direct messages</div><div class="c" data-c="Axari Twin">Axari Twin</div><div class="c">Maya Kim</div></div>';
      f.innerHTML =
        sb +
        '<div class="mn"><div class="mh"><b></b><span></span></div><div class="body"></div><div class="comp"><span class="ph"></span><span class="typing"><span class="tl"></span><i></i><i></i><i></i></span></div></div>';
      fwHost.insertBefore(f, fwHost.firstChild);
      var body = f.querySelector(".body");
      var typ = f.querySelector(".typing");

      function setBeat(i) {
        var b = BEATS[i];
        f.querySelectorAll(".sb .c").forEach(function (c) {
          c.classList.toggle("on", c.getAttribute("data-c") === b.ch);
        });
        f.querySelector(".mh b").textContent = (b.dm ? "" : "# ") + b.ch;
        f.querySelector(".mh span").textContent = b.sub;
        f.querySelector(".ph").textContent =
          "Message " + (b.dm ? b.ch : "#" + b.ch);
        body.innerHTML = "";
        typ.classList.remove("on");
      }

      function html(m) {
        var who, av;
        if (m.ax) {
          av = '<div class="av ax">' + MARK + "</div>";
          who = "<b>Axari Twin</b><span class=\"tag\">APP</span>";
        } else {
          var p = P[m.p];
          av =
            '<div class="av" style="background:' +
            p.c +
            '">' +
            p.i +
            (m.via ? '<span class="badge">' + MARK + "</span>" : "") +
            "</div>";
          who =
            "<b>" +
            p.n +
            "</b>" +
            (m.via
              ? '<span class="via">' + MARK + "Sent using Twin</span>"
              : "");
        }
        var h =
          '<div class="m' +
          (m.ax || m.via ? " tw" : "") +
          '">' +
          av +
          '<div class="mb"><div class="who">' +
          who +
          '<span class="t">' +
          m.t +
          "</span></div>";
        if (m.x) h += '<div class="mx">' + m.x + "</div>";
        if (m.lead) h += '<div class="mx">' + m.lead + "</div>";
        if (m.bl) {
          h += '<ul class="bl">';
          m.bl.forEach(function (b) {
            h +=
              '<li><i class="d ' +
              b[0] +
              '"></i><span>' +
              b[1] +
              "</span></li>";
          });
          h += "</ul>";
        }
        if (m.ctx) {
          h +=
            '<div class="ctx trail">' +
            MARK +
            "<span><b>" +
            (m.via ? "What Twin did for " + OWNER + ":" : "What Twin did:") +
            "</b> " +
            m.ctx +
            "</span></div>";
        }
        if (m.btns) {
          h +=
            '<div class="sbtn"><span>' +
            m.btns[0] +
            "</span><span>" +
            m.btns[1] +
            "</span></div>";
        }
        return h + "</div></div>";
      }

      function add(m, k) {
        body.insertAdjacentHTML("beforeend", html(m));
        var el = body.lastElementChild;
        if (opts.onMsg) opts.onMsg(el, m, k, body);
        body.scrollTop = body.scrollHeight;
      }

      function play(i, done) {
        setBeat(i);
        var ms = BEATS[i].msgs;
        if (RM) {
          ms.forEach(add);
          S.later(done, 6000);
          return;
        }
        var k = 0;
        (function next() {
          if (k >= ms.length) {
            S.later(done, 600);
            return;
          }
          var m = ms[k];
          var idx = k++;
          var isTwin = m.ax || m.via;
          if (isTwin) {
            typ.querySelector(".tl").innerHTML =
              MARK +
              (m.via
                ? "Twin is writing for " + OWNER
                : "Axari Twin is working");
            typ.classList.add("on");
            S.later(function () {
              typ.classList.remove("on");
              add(m, idx);
              S.later(next, readMs(m, RM));
            }, 800);
          } else {
            add(m, idx);
            S.later(next, readMs(m, RM));
          }
        })();
      }

      return { play: play, setBeat: setBeat, el: f };
    }

    function beatMs(i) {
      var t = 600;
      BEATS[i].msgs.forEach(function (m) {
        t += readMs(m, RM) + (m.ax || m.via ? 800 : 0);
      });
      return t;
    }

    var held = false;
    var heldCallback = null;

    function schedWithHold() {
      var ts = [];
      return {
        later: function (fn, ms) {
          var t = setTimeout(function () {
            if (held) {
              heldCallback = fn;
              return;
            }
            fn();
          }, ms);
          ts.push(t);
          return t;
        },
        clear: function () {
          ts.forEach(clearTimeout);
          ts = [];
          heldCallback = null;
        },
      };
    }

    function setHeld(value) {
      held = value;
      host.classList.toggle("persona-demo--held", value);
      if (!value && heldCallback) {
        var fn = heldCallback;
        heldCallback = null;
        fn();
      }
    }

    var S = schedWithHold();
    var fw = $("#a-fw");
    var rc = $("#a-rc");
    var q = $("#a-q");
    var aHead = $(".a-head");
    var steps = $("#a-steps");
    var cur = 0;
    var firstGo = true;
    var transitionMs = RM ? 0 : 280;
    var sl = Slack(fw, S);

    function setPanelsOut(out) {
      [aHead, fw, steps].forEach(function (el) {
        if (el) el.classList.toggle("out", out);
      });
    }

    BEATS.forEach(function (b, i) {
      var s = document.createElement("button");
      s.type = "button";
      s.className = "st";
      s.innerHTML =
        '<div class="bar"><i></i></div><span class="tm">' +
        b.tm +
        '</span><span class="l">' +
        b.label +
        "</span>";
      s.addEventListener("click", function () {
        go(i);
      });
      steps.appendChild(s);
    });

    function applyBeat(i) {
      cur = i;
      var b = BEATS[i];
      steps.querySelectorAll(".st").forEach(function (s, k) {
        s.className = "st" + (k < i ? " done" : "") + (k === i ? " on" : "");
      });
      var on = steps.children[i];
      on.style.setProperty("--dur", beatMs(i) + 2200 + "ms");
      var bar = on.querySelector(".bar i");
      bar.style.animation = "none";
      void bar.offsetWidth;
      bar.style.animation = "";
      $("#a-lab").textContent = b.label;
      $("#a-tm").textContent = b.tm;
      q.textContent = b.q;
      setPanelsOut(false);
      sl.play(i, function () {
        $("#a-rb").textContent = b.big;
        $("#a-rs").textContent = b.sm;
        rc.classList.add("on");
        S.later(function () {
          go((i + 1) % BEATS.length);
        }, 2200);
      });
    }

    function go(i, skipExit) {
      S.clear();
      rc.classList.remove("on");
      if (firstGo || skipExit) {
        firstGo = false;
        applyBeat(i);
        return;
      }
      setPanelsOut(true);
      S.later(function () {
        applyBeat(i);
      }, transitionMs);
    }

    function start() {
      go(cur);
    }

    function stop() {
      S.clear();
    }

    function hold() {
      setHeld(true);
    }

    function unhold() {
      setHeld(false);
    }

    var onVisibility = function () {
      setHeld(document.hidden);
    };
    document.addEventListener("visibilitychange", onVisibility);

    setPanelsOut(true);
    start();

    return {
      pause: hold,
      resume: unhold,
      fadeOut: function (done) {
        setHeld(false);
        stop();
        setPanelsOut(true);
        global.setTimeout(done, transitionMs);
      },
      destroy: function () {
        setHeld(false);
        stop();
        document.removeEventListener("visibilitychange", onVisibility);
        host.classList.remove("persona-demo");
        host.innerHTML = "";
      },
    };
  }

  global.AxariPersonaDemo = {
    create: createPersonaDemo,
    extractConfigFromHtml: extractConfigFromHtml,
  };
})(typeof window !== "undefined" ? window : this);
